import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <Card className="rounded-2xl border bg-card p-8 shadow-sm max-w-sm w-full text-center" data-testid="payment-cancel-card">
        <XCircle className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
        <h1 className="font-heading font-bold text-2xl">Payment cancelled</h1>
        <p className="text-muted-foreground text-sm mt-1">No charge was made. You can take payment again from the calendar.</p>
        <Link to="/calendar"><Button className="rounded-lg mt-6 w-full" data-testid="payment-cancel-back">Back to calendar</Button></Link>
      </Card>
    </div>
  );
}
